import React, { useEffect } from "react";
import cn from "classnames";
import { FormControl, FormLabel } from "@material-ui/core";
import type { FC } from "react";
import { useBulkBaseIndexControl } from "./BulkBaseIndexControl.state";
import { useStyles } from "./BulkBaseIndexControl.styles";
import { DateRangeGroup } from "./DateRangeGroup";
import type { IBulkBaseIndexControlProps } from "./BulkBaseIndexControl.types";

export const BulkBaseIndexControl: FC<IBulkBaseIndexControlProps> = <T extends number | string | unknown = unknown>(props) => {
  const classes = useStyles();
  const {
    state,
    onChangeCheckedHander,
    onChangeValueHander,
  } = useBulkBaseIndexControl<T>(props);

  const label = "Select date";
  const hiddenRadio = state.availableDateRanges.length === 1;
  return (
    <div className={classes.root}>
      <FormControl component="fieldset" className={cn({ [classes.formControl]: true })}>
        <FormLabel component="legend" className={classes.label}>
          {label}
        </FormLabel>

        {state.availableDateRanges.map((dateRange) => {
          const checked = state.selectedRanges.includes(dateRange);
          const items = state.items[dateRange]!;
          const value = state.value[dateRange]!;
          const handleChangeChecked = (checked: boolean) => onChangeCheckedHander(dateRange, checked);
          const handleChangeValue = (value: T) => onChangeValueHander(dateRange, value);

          return (
            <DateRangeGroup
              key={dateRange}
              dateRange={dateRange}
              checked={checked}
              items={items}
              value={value}
              onChange={handleChangeValue}
              onChangeChecked={handleChangeChecked}
              hiddenRadio={hiddenRadio}
            />
          );
        })}
      </FormControl>
    </div>
  );
};
